import { useState, useEffect } from 'react';

import Checkbox from 'components/form-elements/checkbox/Checkbox';

import { ICheckboxGroup, IMessage } from 'source/NFR.types';

interface ICheckboxGroupProps extends ICheckboxGroup {
  setIsChecked?: (isChecked: boolean) => void;
  setMessage?: (message: IMessage) => void;
}

const CheckboxGroup: React.FC<ICheckboxGroupProps> = ({
  options,
  setIsChecked,
  title,
  required,
  requiredText,
  setMessage,
  validationError
}) => {
  const [checkedList, setCheckedList] = useState(options?.map(() => false));
  const onCheck = (e: React.ChangeEvent<HTMLInputElement>, i: number) => {
    if (!setIsChecked) return;
    const checked = e.target.checked;
    setCheckedList(state => state?.map((stateChecked, index) => (i === index ? checked : stateChecked)));
  };
  useEffect(() => {
    if (!setIsChecked) return;
    if (required) {
      if (!checkedList.some(checked => !!checked) && setMessage) {
        setMessage(requiredText);
      }
      setIsChecked(checkedList.some(checked => !!checked));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...checkedList]);
  // setIsChecked is a prop callback - adding causes re-renders

  return (
    <div className="checkbox-group">
      {title && <h2 className="checkbox-group--title">{title}</h2>}
      {validationError && <div className="checkbox-group--validation-error">{validationError}</div>}

      {options?.map((checkbox, i) => (
        <Checkbox
          className="checkbox-group--checkbox"
          key={checkbox.name}
          onChange={e => onCheck(e, i)}
          {...checkbox}
        />
      ))}
    </div>
  );
};

CheckboxGroup.displayName = 'CheckboxGroup';

export default CheckboxGroup;
